import styled from "styled-components"
import colors from "~constants/colors"
import { APP_VERSION } from "~constants/config"

const SiteVersion = () => {
  return (
    <VersionContainer className="site-version">
      <VersionText>{APP_VERSION}</VersionText>
    </VersionContainer>
  )
}

const VersionContainer = styled.div`
  padding: 8px 12px;
  text-align: center;
`

const VersionText = styled.span`
  font-size: 11px;
  color: ${colors.gray7};
  letter-spacing: 0.3px;
  font-weight: 500;
`

export default SiteVersion
